import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';
import { TopbarActions } from '../../actions/topbar/topbar.actions';

@Injectable()
export class TopbarEffects {


  loadTopbars$ = createEffect(() => {
    return this.actions$.pipe(

      ofType(TopbarActions.loadTopbars),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => EMPTY as Observable<{ type: string }>)
    );
  });

  constructor(private actions$: Actions) {}
}
